import {
  TaskTrackerTaskHistory,
  TaskTrackerTaskHistoryActor,
  TaskTrackerTaskHistoryEvent,
} from '../store/taskTracker.types'
import {
  ApiTaskHistoryActor,
  ApiTaskHistoryEvent,
  ApiTaskHistoryResponse,
} from './taskTracker.api.types'

export const mapTaskHistoryActorFromApi = (
  item: ApiTaskHistoryActor | null | undefined,
): TaskTrackerTaskHistoryActor | null => {
  if (!item) return null

  return {
    id: Number(item.id),
    name: String(item.name ?? '').trim(),
    email: item.email ?? null,
    phone: item.phone ?? null,
    avatarPath: item.avatar_path ?? null,
  }
}

export const mapTaskHistoryEventFromApi = (
  item: ApiTaskHistoryEvent,
): TaskTrackerTaskHistoryEvent => ({
  id: Number(item.id),
  eventType: String(item.event_type ?? '').trim(),
  eventLabel: String(item.event_label ?? '').trim(),
  eventData:
    item.event_data && typeof item.event_data === 'object'
      ? item.event_data
      : null,
  createdAt: String(item.created_at ?? ''),
  actor: mapTaskHistoryActorFromApi(item.actor),
})

export const mapTaskHistoryFromApi = (
  item: ApiTaskHistoryResponse,
): TaskTrackerTaskHistory => ({
  taskId: Number(item.task_id),
  events: (item.events ?? []).map(mapTaskHistoryEventFromApi),
})
